// Product identity. "Cat vs AI" is the product/game name (header, splash, store,
// share). The in-fiction station is still "Cradle-7 / Колыбель-7" — that lives in
// i18n lore strings and is intentionally NOT renamed here.
export const PRODUCT_NAME = 'Cat vs AI';
export const PRODUCT_NAME_DISPLAY = 'CAT VS AI';
export const STATION_NAME = 'Cradle-7';
// Single source of truth for the displayed version. package.json is stuck at
// 0.0.1; real releases are git tags (v0.4.0 …). Bump this with each release tag.
export const VERSION = 'v0.6.2';
